import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { href: '/', label: '首页' },
      { href: '/category/all', label: '作品全集' },
      { href: '/category/latest', label: '最新作品' },
      { href: '/category/masterpiece', label: '代表作' },
      { href: '/category/photo-book', label: '写真集' },
      { href: '/category/fan-news', label: '粉丝资讯' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { href: '/about', label: '品牌介绍' },
      { href: '/about', label: '口碑评价' },
      { href: '/about', label: '联系我们' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-foreground-900">
                大桥未久官方专区
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-md">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href={`mailto:${siteInfo.contact.email}`}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="发送邮件"
                rel="nofollow"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 大桥未久官方专区. 本站为粉丝资讯平台，仅供交流学习使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>友情链接：</span>
            <a href="#" className="hover:text-primary-500 transition-colors" rel="nofollow">粉丝社区</a>
            <a href="#" className="hover:text-primary-500 transition-colors" rel="nofollow">作品资料库</a>
          </div>
        </div>
      </div>
    </footer>
  );
}